<template>
    <div v-if="additionals">
        <div v-if="additionals.plantaoId">
            <rkm-table
                :fields="fields.datatables.fila"
                :items="filteredItems"
                hide-pagination
            >
                <template v-slot:cell(idade)="row">
                    {{ row.item.atendimento.paciente.cidadao.idade.anos }} {{ row.item.atendimento.paciente.cidadao.idade.anos > 1 ? 'anos' : 'ano' }},
                    {{ row.item.atendimento.paciente.cidadao.idade.meses }} {{ row.item.atendimento.paciente.cidadao.idade.meses > 1 ? 'meses' : 'mês ' }} e
                    {{ row.item.atendimento.paciente.cidadao.idade.dias }} {{ row.item.atendimento.paciente.cidadao.idade.dias > 1 ? 'dias' : 'dia' }}
                </template>

                <template v-slot:cell(nome)="row">
                    {{ row.item.atendimento.paciente.cidadao.nome }}

                    <template v-if="row.item.atendimento.paciente.cidadao.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ row.item.atendimento.paciente.cidadao.nomeSocial }})</strong>
                    </template>
                </template>

                <template v-slot:cell(atendimento.dataHoraProximaReavaliacao)="row">
                    {{ row.item.atendimento.medicoDesfechoNome || row.item.atendimento.dataHoraProximaReavaliacao }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click.stop="$router.push({ name: atenderRoute, params: { id: item.id, plantaoId: additionals.plantaoId } })"
                        color="primary"
                        title="Atender"
                        authorize="store-pronto-atendimento-paciente-observacao"
                        small
                    >
                        <rkm-icon icon="plus" />
                    </rkm-button>

                    <rkm-button
                        color="info"
                        small
                        title="Imprimir"
                        @click="getImpressoes(item.atendimento.id, enums.setorTipo.OBSERVACAO)
                            .then(impressoes => $refs.ModalImpressao.open(impressoes, item.atendimento.id))"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalEvasao.open(item.id)"
                        color="danger"
                        title="Evadir"
                        small
                    >
                        <rkm-icon icon="running" />
                    </rkm-button>
                </template>
            </rkm-table>

            <ModalEvasao
                ref="ModalEvasao"
                @save="load()"
            />

            <ModalImpressao
                from-observacao
                ref="ModalImpressao"
            />
        </div>

        <rkm-alert color="warning" v-else>
            Não existe nenhum plantão cadastrado para este usuário.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalEvasao from '@/components/pronto-atendimento/fila/components/evasao/Modal'
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Mixin.
import { repository, error, stringCase, websocket } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from "vuex"

// Enums.
import modulo from '@/enums/administracao/modulo'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

export default {
    components: { ModalEvasao, ModalImpressao },
    computed: {
        ...mapGetters({ centroCusto: 'getCentroCusto', lotacao: 'getLotacao', customer: 'getCustomer' }),
        fields() {

            return {
                datatables: {
                    fila: [
                        { key: 'opcaoEntrada.tipoAtendimento', label: 'Tipo de atendimento' },
                        { key: 'atendimento.recepcao.atendidoEm', label: 'Data do atendimento' },
                        { key: 'nome', label: 'Nome' },
                        { key: 'idade', label: 'Idade' },
                        { key: 'atendimento.tempoObservacao', label: 'Tempo em observação' },
                        { key: 'atendimento.dataHoraProximaReavaliacao', label: 'Próxima Reavaliação / Desfecho' },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ]
                }
            }
        },
        atenderRoute() {
            if (this.centroCusto.setor.tipoId === this.enums.setorTipo.CONSULTORIO) {
                return 'pronto-atendimento-atendimento-medico-create'
            }
            else if (this.centroCusto.setor.tipoId === this.enums.setorTipo.EXAMES) {
                return 'pronto-atendimento-exame-imagem-create'
            }
            else {
                return 'pronto-atendimento-paciente-observacao-create'
            }
        },
        filteredItems() {
            let filtered = this.items

            if (this.additionals.plantaoFaixaEtariaId) {

                filtered = filtered.filter(item => item.opcaoEntrada.faixaEtariaId == this.additionals.plantaoFaixaEtariaId
                    || !item.opcaoEntrada.faixaEtariaId )
            }

            return filtered
        },
    },
    created() {
        this.repositories = {
            observacao: this.getConectaSusRepository('prontoAtendimento.observacao'),
            fila: this.getConectaSusRepository('prontoAtendimento.fila')
        }
    },
    data: () => ({
        additionals: null,
        items: [],
        enums: {
            modulo,
            preferenciaNome,
            setorTipo,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        init() {

            const setorTipoId = this.enums.setorTipo.OBSERVACAO

            this.pusher.subscribe(`private-${this.customer.link}-painel-senha-fila`)
                .bind(`${setorTipoId}.${this.centroCusto.id}.${this.enums.modulo.PRONTO_ATENDIMENTO}.updated`, ({ fila }) => {

                    this.items = this.snakeObjectKeysToCamelRecursive(fila)
                })
        },
        load() {

            this.setLoading()

            this.repositories.observacao.index({
                centro_custo_id: this.centroCusto.id,
                setor_tipo_id: this.enums.setorTipo.OBSERVACAO
            })
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.items = data.fila

                })
                .finally(() => this.unsetLoading())
        },
        async getImpressoes(atendimentoId, setorTipoId) {

            let impressoes = {}

            this.setLoading()

            try {

                impressoes = (await this.repositories.fila.getImpressoes(atendimentoId, setorTipoId)).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return impressoes
        },
    },
    mounted() {
        this.init()
        this.load()
    },
    mixins: [repository, error, stringCase, websocket],
}
</script>